import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PutApiDependentMutationRequest,
  PutApiDependentMutationResponse,
  PutApiDependent401,
  PutApiDependent403,
} from "../../../types/PutApiDependent";

export function getPutApiDependentUrl() {
  return `/api/Dependent` as const;
}

/**
 * {@link /api/Dependent}
 */
export async function putApiDependent(
  data?: PutApiDependentMutationRequest,
  config: Partial<RequestConfig<PutApiDependentMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PutApiDependentMutationResponse,
    ResponseErrorConfig<PutApiDependent401 | PutApiDependent403>,
    PutApiDependentMutationRequest
  >({
    method: "PUT",
    url: getPutApiDependentUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
